import { BehaviorSubject, combineLatest, from } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { resolveHtmlContentCalculations } from "../../lib/calculations";
import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { ContentSettings } from "@cs-ts/content-settings";
import { CalculationContext } from "./__CalculationContextInterface";
import { useMainStore } from "@/mainStore";
import { KnownFeatureFlags } from "@cs/KnownFeatureFlags";

export default class ContentDef extends BaseElementDef<ContentSettings, FormDefinitionItem<ContentSettings>, FormItem> {
    declare _effectiveHtmlContent$: BehaviorSubject<string>;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<ContentSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFContent"; // TODO - not hardcoded?
    }

    effectiveHtmlContent$() {
        if (this._effectiveHtmlContent$ == null) {
            this._effectiveHtmlContent$ = new BehaviorSubject("");
            const htmlContent = this.definition.settings.htmlContent;
            if ((this.definition.settings.htmlCalculations || []).length != 0) {
                from(useMainStore().isFeatureFlagActiveAsync(KnownFeatureFlags.UseHtmlDirectId.Id))
                    .pipe(
                        switchMap(useHtmlDirectId => {
                            const htmlCalculations$ = [];
                            for (const htmlCalculation of this.definition.settings.htmlCalculations ?? []) {
                                htmlCalculations$.push(this.resolveCalculation(htmlCalculation.calculationId!).pipe(map(text => ({ id: useHtmlDirectId ? htmlCalculation.id ?? htmlCalculation.calculationId : htmlCalculation.calculationId, text }))));
                            }
                            return combineLatest(htmlCalculations$).pipe(map(calculations => resolveHtmlContentCalculations(calculations, htmlContent)));
                        }),
                    )
                    .subscribe(resolvedHtmlContent => {
                        this._effectiveHtmlContent$?.next(resolvedHtmlContent);
                    });
            } else {
                this._effectiveHtmlContent$ = new BehaviorSubject(htmlContent ?? "");
            }
        }
        return this._effectiveHtmlContent$;
    }
}
